import { io } from "socket.io-client";

import * as Toastr from 'toastr';

Toastr.options.positionClass = "toast-bottom-right";
Toastr.options.titleClass = "toast-header";
Toastr.options.messageClass = "toast-body";

const socket = io();

socket.on("connect", () => {
    $('#avatarContainer').replaceClass('avatar-offline', 'avatar-online');
    // Toastr.info('Backend connection restored!', '<h4 class="mb-0 me-auto">BillingConnector notification</h4>');
});

socket.on("disconnect", () => {
    Toastr.info('Backend connection lost!', '<h4 class="mb-0 me-auto">Middleware notification</h4><small class="text-muted">now</small><button type="button" class="ms-3 mb-n1 btn-close" data-bs-dismiss="toast" aria-label="Close"></button>');
    $('#avatarContainer').replaceClass('avatar-online', 'avatar-offline');
});

socket.on("connect_error", (err) => {
    console.log(`connect_error due to ${err.message}`);
  });

socket.on("order_received", () => {
    Toastr.info('New order received!', '<h4 class="mb-0 me-auto">Middleware notification</h4><small class="text-muted">now</small><button type="button" class="ms-3 mb-n1 btn-close" data-bs-dismiss="toast" aria-label="Close"></button>');
});

export default socket;